import React from "react";

import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import Textarea from "@peracto/peracto-editor-ui/dist/Textarea";
import File from "@peracto/peracto-editor-ui/dist/File";
import Select from "@peracto/peracto-editor-ui/dist/Select";
import Checkbox from "@peracto/peracto-editor-ui/dist/Checkbox";

const InfoPanelForm = ({
    onChange,
    state: {
        url = "",
        mobileUrl = "",
        displayOrder = "image-text",
        infoPanelHeading = "Heading",
        infoPanelText = "",
        infoPanelPrimaryButtonText = "",
        infoPanelPrimaryButtonLink = "",
        infoPanelPrimaryButtonColour = "primary",
        infoPanelSecondaryButtonText = "",
        infoPanelSecondaryButtonLink = "",
        infoPanelSecondaryButtonColour = "secondary",
        showCallbirdButton = false,
    },
}) => {
    const buttonColourOptions = [
        { label: "Blue", value: "primary" },
        { label: "Orange", value: "tertiary" },
        { label: "Green", value: "sextary" },
        { label: "Pink", value: "quaternary" },
        { label: "Yellow", value: "quinary" },
        { label: "Transparent", value: "transparent" },
    ];

    const displayOrderOptions = [
        { label: "Image/Text", value: "image-text" },
        { label: "Text/Image", value: "text-image" },
    ];

    return (
        <>
            <Select
                label="Desktop Display Order"
                value={displayOrder}
                onChange={(e) => onChange({ displayOrder: e.value })}
                options={displayOrderOptions}
            />

            <File
                label="Image URL"
                value={url}
                onChange={(value) => onChange({ url: value })}
                isInline={false}
            />

            <File
                label="Mobile Image URL"
                value={mobileUrl}
                onChange={(value) => onChange({ mobileUrl: value })}
                isInline={false}
            />

            <TextInput
                label="Heading"
                value={infoPanelHeading}
                onChange={(e) => onChange({ infoPanelHeading: e.target.value })}
            />

            <Textarea
                label="Text"
                value={infoPanelText}
                height={300}
                onChange={(e, editor) => {
                    onChange({
                        infoPanelText: editor.getData(),
                    });
                }}
            />

            <TextInput
                label="Primary Button Text"
                value={infoPanelPrimaryButtonText}
                onChange={(e) =>
                    onChange({ infoPanelPrimaryButtonText: e.target.value })
                }
            />

            <TextInput
                label="Primary Button Link"
                value={infoPanelPrimaryButtonLink}
                onChange={(e) =>
                    onChange({ infoPanelPrimaryButtonLink: e.target.value })
                }
            />

            <Select
                label="Primary Button Colour"
                value={infoPanelPrimaryButtonColour}
                onChange={(e) =>
                    onChange({ infoPanelPrimaryButtonColour: e.value })
                }
                options={buttonColourOptions}
            />

            <TextInput
                label="Secondary Button Text"
                value={infoPanelSecondaryButtonText}
                onChange={(e) =>
                    onChange({ infoPanelSecondaryButtonText: e.target.value })
                }
            />

            <TextInput
                label="Secondary Button Link"
                value={infoPanelSecondaryButtonLink}
                onChange={(e) =>
                    onChange({ infoPanelSecondaryButtonLink: e.target.value })
                }
            />

            <Select
                label="Secondary Button Colour"
                value={infoPanelSecondaryButtonColour}
                onChange={(e) =>
                    onChange({ infoPanelSecondaryButtonColour: e.value })
                }
                options={buttonColourOptions}
            />

            <Checkbox
                label="Show Callbird Button"
                checked={showCallbirdButton}
                onChange={(e) =>
                    onChange({ showCallbirdButton: e.target.checked })
                }
            />
        </>
    );
};

export default InfoPanelForm;
